import { useEffect, useState } from 'react';
import { putJobSummary } from '../api';
import { emptyJobDetails } from '../constants';
import { JobSummary } from '../interfaces';
import { useSnackbar } from 'notistack';

export default function useEditJobDetails(
  editingSummary: JobSummary,
  onSave: () => void,
) {
  const { enqueueSnackbar } = useSnackbar();
  const [jobDetails, setJobDetails] = useState<JobSummary>(emptyJobDetails);
  const [loading, setLoading] = useState<boolean>(false);

  const onChangeVendor = (newVendor: string) => {
    setJobDetails({
      ...jobDetails,
      vendor: newVendor,
    });
  };

  const onSelectPriorityName = (option: { value: any, label: string }) => {
    if (option?.label !== undefined) {
      setJobDetails({
        ...jobDetails,
        priorityName: option.label,
      });
    }
  };

  const onSelectStatusName = (option: { value: any, label: string}) => {
    if (option?.label !== undefined) {
      setJobDetails({
        ...jobDetails,
        statusName: option.label,
      });
    }
  };

  const onSelectTravelModeName = (option: { value: any, label: string }) => {
    if (option?.label !== undefined) {
      setJobDetails({
        ...jobDetails,
        travelModeName: option.label,
      });
    }
  };

  const onChangeDescription = (newDescription: string) => {
    setJobDetails({
      ...jobDetails,
      description: newDescription,
    });
  };

  const onChangeInitialPlannedPickupDate = (newDate: Date | null) => {
    if (newDate) {
      setJobDetails({
        ...jobDetails,
        initialPlannedPickupDate: newDate.toISOString(),
      });
    }
  };

  const onChangeRevisedPickupDate = (newDate: Date | null) => {
    if (newDate) {
      setJobDetails({
        ...jobDetails,
        revisedPickupDate: newDate.toISOString(),
      });
    }
  };

  const onChangeActualPickupDate = (newDate: Date | null) => {
    if (newDate) {
      setJobDetails({
        ...jobDetails,
        actualPickupDate: newDate.toISOString(),
      });
    }
  };

  const onChangeHandoffLocation = (newLocation: string) => {
    setJobDetails({
      ...jobDetails,
      handoffLocation: newLocation,
    });
  };

  const onChangeInitialPlannedStagingDate = (newDate: Date | null) => {
    if (newDate) {
      setJobDetails({
        ...jobDetails,
        initialPlannedStagingDate: newDate.toISOString(),
      });
    }
  };

  const onChangeRevisedStagingDate = (newDate: Date | null) => {
    if (newDate) {
      setJobDetails({
        ...jobDetails,
        revisedStagingDate: newDate.toISOString(),
      });
    }
  };

  const onClickSave = async () => {
    await putJobSummary(jobDetails, setLoading, enqueueSnackbar);
    setJobDetails(emptyJobDetails);
    onSave();
  };

  useEffect(() => {
    setJobDetails(editingSummary);
  }, [editingSummary])

  return {
    jobDetails,
    onChangeVendor,
    onSelectPriorityName,
    onSelectStatusName,
    onSelectTravelModeName,
    onChangeDescription,
    onChangeInitialPlannedPickupDate,
    onChangeRevisedPickupDate,
    onChangeActualPickupDate,
    onChangeHandoffLocation,
    onChangeInitialPlannedStagingDate,
    onChangeRevisedStagingDate,
    onClickSave,
    loading,
  };
}
